import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import search from "../../assets/search.png";

type LoginUser = {
  username: string;
  fullName?: string;
  specialty?: string;
  protocolMode?: "dynamic" | "template";
  role: "admin" | "superadmin" | "test" | "task";
};

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (event?: React.FormEvent) => {
    event?.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.error || "Неверный логин или пароль");
      }

      const user = data as LoginUser;

      localStorage.setItem("username", user.username);
      localStorage.setItem("fullName", user.fullName || "");
      localStorage.setItem("specialty", user.specialty || "");
      localStorage.setItem("protocolMode", user.protocolMode || "dynamic");
      localStorage.removeItem("resultSaved");
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("role", user.role);

      if (user.role === "test") {
        navigate("/choose-test");
      } else if (user.role === "task") {
        localStorage.removeItem("tasks");
        localStorage.removeItem("taskAttemptId");
        localStorage.removeItem("taskResult");
        navigate("/choose-task");
      } else if (user.role === "admin") {
        navigate("/admin/students");
      } else if (user.role === "superadmin") {
        navigate("/superadmin/results");
      }
    } catch (error) {
      alert(error instanceof Error ? error.message : "Неверный логин или пароль");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="title"></div>
      <div className="title22">
        <div>Система проведения аккредитации специалистов</div>
        <div className="imgCont">
          <img src={search} alt="" style={{ width: 20 }} />
        </div>
      </div>
      <div className="login-container">
        <form className="inputs-cont" onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Логин"
            value={username}
            className="inputss"
            onChange={(e) => setUsername(e.target.value)}
          />
          <div className="password-input-wrap">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Пароль"
              value={password}
              className="inputss password-input"
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className={`password-toggle ${showPassword ? "visible" : ""}`}
              aria-label={showPassword ? "Скрыть пароль" : "Показать пароль"}
              onClick={() => setShowPassword((value) => !value)}
            >
              <span className="password-eye" />
            </button>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              fontSize: 14,
              whiteSpace: "nowrap",
            }}
          >
            <input type="checkbox" />
            <div>Запомнить логин</div>
          </div>

          <button type="submit" className="login-submit-button" disabled={isSubmitting}>
            {isSubmitting ? "Вход..." : "Вход"}
          </button>
        </form>
        <div className="forget_cont">
          <div className="forget" style={{ height: "50%" }}>
            <div style={{ color: "#009688", cursor: "pointer" }}>
              Забыли логин или пароль?
            </div>
            <div>В Вашем браузере должен быть разрешен прием cookies</div>
          </div>
          <div style={{ height: "50%" }}></div>
        </div>
      </div>
      <div className="footer"></div>
    </div>
  );
};

export default LoginPage;
